import { initializeApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { connectStorageEmulator, getStorage } from 'firebase/storage'

import { initAnalytics } from './analytics.ts'

export const initFirebase = () => {
  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  }

  const app = initializeApp(firebaseConfig)

  if (import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-member-access
    ;(globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN = import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(import.meta.env.VITE_RECAPTCHA_KEY),
    isTokenAutoRefreshEnabled: true,
  })

  initAnalytics(app)

  if (import.meta.env.VITE_EMULATOR_HOST) {
    const emulatorHost = import.meta.env.VITE_EMULATOR_HOST
    const authPort = Number(import.meta.env.VITE_EMULATOR_AUTH_PORT)
    const functionsPort = Number(import.meta.env.VITE_EMULATOR_FUNCTIONS_PORT)
    const firestorePort = Number(import.meta.env.VITE_EMULATOR_FIRESTORE_PORT)
    const storagePort = Number(import.meta.env.VITE_EMULATOR_STORAGE_PORT)

    connectAuthEmulator(getAuth(app), `http://${emulatorHost}:${authPort}`)
    connectFunctionsEmulator(getFunctions(app), emulatorHost, functionsPort)
    connectFunctionsEmulator(getFunctions(app, 'northamerica-northeast1'), emulatorHost, functionsPort)
    connectFirestoreEmulator(getFirestore(app), emulatorHost, firestorePort)
    connectStorageEmulator(getStorage(app), emulatorHost, storagePort)
  }
}
